import { useLang } from '@/i18n';
import EcoPicture from 'eco-design/base/eco-picture';
import getLocal from 'eco-design-reliance/getLocal';
import css from './index.module.scss';

const DEFAULT_IMGS = [
    'https://websiteoss.ecoflow.com/figma-uploads/1767774675615-g450ut-compressed-home-carousel-banner.jpg',
    'https://websiteoss.ecoflow.com/figma-uploads/1767774700508-vdzy8g-compressed-pad.jpg',
    'https://websiteoss.ecoflow.com/figma-uploads/1767774720171-106yxu-compressed-mob.jpg',
] as const;

const EU_IMGS = [
    'https://websiteoss.ecoflow.com/figma-uploads/1787644454293-jklcma-compressed-home-carousel-banner.webp',
    'https://websiteoss.ecoflow.com/figma-uploads/1787644532571-xy83we-compressed-pad.webp',
    'https://websiteoss.ecoflow.com/figma-uploads/1787644657178-3k2dcc-compressed-mob.webp',
] as const;

export default function TheComp() {
    const { t } = useLang('aboutus.A');
    const { locale } = getLocal();
    const isEuBanner = locale ? ['de', 'uk', 'eu', 'fr'].includes(locale) : false;

    return (
        <section id="about-us-A" className={`about-us-A ${css.section} GtmModuleData-section`} data-section-id="About-Us-A">
            <div className="img">
                <EcoPicture
                    className="picture"
                    fetchPriority="high"
                    loading="eager"
                    jpg={isEuBanner ? [...EU_IMGS] : [...DEFAULT_IMGS]}
                    alt={t('title')}
                />
            </div>
            <div className="info">
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>
            </div>
        </section>
    );
}
